/** Pendant zu `Client/Components/Base/IwmBaseSidebar.razor` — Basisklasse als Hook. */

import { useCallback, useMemo, useRef, useState } from 'react';

export interface SidebarController {
  visible: boolean;
  id: number;
  /** Standard 0 — `Show(int id = 0)` im Altclient. */
  show(id?: number): void;
  hide(): void;
}

export interface SidebarCallbacks {
  onShow?(): void;
  onHide?(): void;
}

export function useSidebar(callbacks?: SidebarCallbacks): SidebarController {
  const [state, setState] = useState({ visible: false, id: 0 });

  // Die Rückrufe wechseln bei jedem Rendern des Aufrufers ihre Identität; `show`/`hide`
  // bleiben dadurch stabil und können ohne Nebenwirkung in Abhängigkeitslisten stehen.
  const latest = useRef(callbacks);
  latest.current = callbacks;

  const show = useCallback((id = 0) => {
    setState({ visible: true, id });
    latest.current?.onShow?.();
  }, []);

  const hide = useCallback(() => {
    setState((current) => ({ ...current, visible: false }));
    latest.current?.onHide?.();
  }, []);

  return useMemo(
    () => ({ visible: state.visible, id: state.id, show, hide }),
    [hide, show, state.id, state.visible],
  );
}
